import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private modalService: NgbModal) {}

  openWarningUser(inputs: any): Promise<any> {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      windowClass: 'blue-modal',
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.title = inputs?.title || `Attenzione`;
    modalRef.componentInstance.message =
      inputs?.message ||
      `La sessione risulta inattiva, tra 5 minuti sarai riportato alla login in automatico, altrimenti puoi eseguire il logout o proseguire con l'operatività`;
    modalRef.componentInstance.nextBtn = inputs?.nextBtn || 'Prosegui';
    modalRef.componentInstance.cancelBtn = inputs?.cancelBtn || 'Logout';
    modalRef.componentInstance.classConfirmBtn = inputs?.classConfirmBtn || 'btn-primary';
    modalRef.componentInstance.classCancelBtn = inputs?.classCancelBtn || 'btn-outline';
    return modalRef.result;
  }
}
